(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qube-collectors-vault"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qube-torn-pager')) {
    class QubeTornPager extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;

        this._rail = this.querySelector('.qube-torn-gallery__rail');
        this._pager = this.querySelector('.qube-torn-gallery__pager');
        if (!this._rail || !this._pager) return;

        this._connected = true;
        this._frame = 0;
        this._targets = [];
        this._buttons = [];
        this._onScroll = () => this._scheduleUpdate();
        this._onResize = () => this._scheduleBuild();
        this._rail.addEventListener('scroll', this._onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(this._onResize);
          this._resizeObserver.observe(this._rail);
        } else {
          window.addEventListener('resize', this._onResize, { passive: true });
        }

        this._build();
      }

      disconnectedCallback() {
        if (!this._connected) return;
        this._rail.removeEventListener('scroll', this._onScroll);
        this._resizeObserver?.disconnect();
        window.removeEventListener('resize', this._onResize);
        cancelAnimationFrame(this._frame);
        this._connected = false;
      }

      _scheduleBuild() {
        cancelAnimationFrame(this._frame);
        this._frame = requestAnimationFrame(() => this._build());
      }

      _scheduleUpdate() {
        if (this._frame) return;
        this._frame = requestAnimationFrame(() => this._update());
      }

      _build() {
        this._frame = 0;
        const entries = Array.from(this._rail.children);
        const maxScroll = Math.max(0, this._rail.scrollWidth - this._rail.clientWidth);
        const railLeft = this._rail.getBoundingClientRect().left;
        const targets = [];

        entries.forEach((entry) => {
          const rawTarget = entry.getBoundingClientRect().left - railLeft + this._rail.scrollLeft;
          const target = Math.min(maxScroll, Math.max(0, Math.round(rawTarget)));
          if (!targets.some((value) => Math.abs(value - target) < 2)) targets.push(target);
        });

        this._targets = targets;
        this._pager.replaceChildren();

        targets.forEach((target, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'qube-torn-gallery__segment';
          button.setAttribute('aria-label', `View theme group ${index + 1}`);
          button.title = `View theme group ${index + 1}`;
          button.addEventListener('click', () => {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this._rail.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
          });
          this._pager.appendChild(button);
        });

        this._buttons = Array.from(this._pager.children);
        this.dataset.pagerReady = targets.length > 1 ? 'true' : 'false';
        this._update();
      }

      _update() {
        this._frame = 0;
        if (!this._targets.length) return;

        let activeIndex = 0;
        let closestDistance = Infinity;
        this._targets.forEach((target, index) => {
          const distance = Math.abs(this._rail.scrollLeft - target);
          if (distance < closestDistance) {
            activeIndex = index;
            closestDistance = distance;
          }
        });

        this._buttons.forEach((button, index) => {
          if (index === activeIndex) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('qube-torn-pager', QubeTornPager);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qube-craft-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qube-craft-story-pager')) {
    class QubeCraftStoryPager extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;

        this._rail = this.querySelector('.qube-craft-story__rail');
        this._pager = this.querySelector('.qube-craft-story__pager');
        if (!this._rail || !this._pager) return;

        this._connected = true;
        this._frame = 0;
        this._targets = [];
        this._buttons = [];
        this._onScroll = () => this._scheduleUpdate();
        this._onResize = () => this._scheduleBuild();
        this._rail.addEventListener('scroll', this._onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(this._onResize);
          this._resizeObserver.observe(this._rail);
        } else {
          window.addEventListener('resize', this._onResize, { passive: true });
        }

        this._build();
      }

      disconnectedCallback() {
        if (!this._connected) return;
        this._rail.removeEventListener('scroll', this._onScroll);
        this._resizeObserver?.disconnect();
        window.removeEventListener('resize', this._onResize);
        cancelAnimationFrame(this._frame);
        this._connected = false;
      }

      _scheduleBuild() {
        cancelAnimationFrame(this._frame);
        this._frame = requestAnimationFrame(() => this._build());
      }

      _scheduleUpdate() {
        if (this._frame) return;
        this._frame = requestAnimationFrame(() => this._update());
      }

      _build() {
        this._frame = 0;
        const entries = Array.from(this._rail.children);
        const maxScroll = Math.max(0, this._rail.scrollWidth - this._rail.clientWidth);
        const railLeft = this._rail.getBoundingClientRect().left;
        const targets = [];

        entries.forEach((entry) => {
          const rawTarget = entry.getBoundingClientRect().left - railLeft + this._rail.scrollLeft;
          const target = Math.min(maxScroll, Math.max(0, Math.round(rawTarget)));
          if (!targets.some((value) => Math.abs(value - target) < 2)) targets.push(target);
        });

        this._targets = targets;
        this._pager.replaceChildren();

        targets.forEach((target, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'qube-craft-story__segment';
          button.setAttribute('aria-label', `View story ${index + 1}`);
          button.title = `View story ${index + 1}`;
          button.addEventListener('click', () => {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this._rail.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
          });
          this._pager.appendChild(button);
        });

        this._buttons = Array.from(this._pager.children);
        this.dataset.pagerReady = targets.length > 1 ? 'true' : 'false';
        this._update();
      }

      _update() {
        this._frame = 0;
        if (!this._targets.length) return;

        let activeIndex = 0;
        let closestDistance = Infinity;
        this._targets.forEach((target, index) => {
          const distance = Math.abs(this._rail.scrollLeft - target);
          if (distance < closestDistance) {
            activeIndex = index;
            closestDistance = distance;
          }
        });

        this._buttons.forEach((button, index) => {
          if (index === activeIndex) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('qube-craft-story-pager', QubeCraftStoryPager);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qube-hero-poster"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'qube-poster-hero-v3';

    if (customElements.get(elementName)) return;

    class QubePosterHero extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-qube-hero-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-qube-hero-slide]'));
        this.controls = this.querySelector('[data-qube-hero-controls]');
        this.toggleButton = this.querySelector('[data-qube-hero-toggle]');
        this.dots = Array.from(this.querySelectorAll('[data-qube-hero-dot]'));
        this.status = this.querySelector('[data-qube-hero-status]');

        if (!this.viewport || !this.slides.length) return;

        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.hasMultipleSlides = this.slides.length > 1;

        if (!this.hasMultipleSlides) return;

        this.slideControls = this.slides.map((slide) => Array.from(slide.querySelectorAll('a, button')));
        this.interval = Number(this.dataset.interval) || 7000;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.prefersReducedMotion;
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.pageReady = document.readyState === 'complete';
        this.userPaused = false;
        this.interactionPaused = false;
        this.inView = true;
        this.suppressClick = false;
        this.pendingIndex = null;
        this.pointerId = null;
        this.preparedSwipeIndex = null;
        this.progressFrame = null;
        this.idleId = null;
        this.idleType = null;

        this.handleControls = this.onControlsClick.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);
        this.handlePointerDown = this.onPointerDown.bind(this);
        this.handlePointerMove = this.onPointerMove.bind(this);
        this.handlePointerEnd = this.onPointerEnd.bind(this);
        this.handleClickCapture = this.onClickCapture.bind(this);
        this.handleVisibility = this.onVisibilityChange.bind(this);
        this.handleWindowLoad = this.onWindowLoad.bind(this);
        this.handleMouseEnter = () => this.setInteractionPaused(true);
        this.handleMouseLeave = () => this.setInteractionPaused(false);
        this.handleFocusIn = () => this.setInteractionPaused(true);
        this.handleFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.setInteractionPaused(false);
        };

        this.controls?.addEventListener('click', this.handleControls);
        this.viewport.addEventListener('keydown', this.handleKeydown);
        this.viewport.addEventListener('pointerdown', this.handlePointerDown);
        this.viewport.addEventListener('pointerup', this.handlePointerEnd);
        this.viewport.addEventListener('pointercancel', this.handlePointerEnd);
        this.viewport.addEventListener('click', this.handleClickCapture, true);

        this.loadSlide(this.index, 'high');
        this.syncSlides();

        if (this.autoplay) {
          document.addEventListener('visibilitychange', this.handleVisibility);

          if (this.pauseOnHover) {
            this.addEventListener('mouseenter', this.handleMouseEnter);
            this.addEventListener('mouseleave', this.handleMouseLeave);
            this.addEventListener('focusin', this.handleFocusIn);
            this.addEventListener('focusout', this.handleFocusOut);
          }

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              this.inView = entries[0]?.isIntersecting ?? true;

              if (this.inView) {
                this.queueNextImage();
              } else {
                this.cancelQueuedImage();
              }

              this.schedule();
            }, { threshold: 0.3 });
            this.observer.observe(this);
          }

          if (this.pageReady) {
            this.queueNextImage();
            this.schedule();
          } else {
            window.addEventListener('load', this.handleWindowLoad, { once: true });
          }
        }

        if (this.toggleButton) this.toggleButton.hidden = !this.autoplay;
      }

      disconnectedCallback() {
        if (!this.viewport || !this.hasMultipleSlides) return;

        this.controls?.removeEventListener('click', this.handleControls);
        this.viewport.removeEventListener('keydown', this.handleKeydown);
        this.viewport.removeEventListener('pointerdown', this.handlePointerDown);
        this.stopPointerTracking();
        this.viewport.removeEventListener('pointerup', this.handlePointerEnd);
        this.viewport.removeEventListener('pointercancel', this.handlePointerEnd);
        this.viewport.removeEventListener('click', this.handleClickCapture, true);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        window.removeEventListener('load', this.handleWindowLoad);
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        this.observer?.disconnect();
        window.clearTimeout(this.timer);
        window.clearTimeout(this.clickResetTimer);
        window.cancelAnimationFrame(this.progressFrame);
        this.pendingIndex = null;
        this.cancelQueuedImage();
      }

      loadSlide(index, priority = 'low') {
        const slide = this.slides[index];
        if (!slide) return null;

        const image = slide.querySelector('img.qube-poster-hero__image');
        if (slide.dataset.loaded === 'true') return image;

        slide.querySelectorAll('img[data-qube-src], img[data-qube-srcset]').forEach((lazyImage) => {
          lazyImage.loading = 'eager';
          lazyImage.setAttribute(
            'fetchpriority',
            lazyImage.classList.contains('qube-poster-hero__image') ? priority : 'low'
          );
        });

        slide.querySelectorAll('[data-qube-srcset]').forEach((element) => {
          element.setAttribute('srcset', element.dataset.qubeSrcset);
          element.removeAttribute('data-qube-srcset');
        });

        slide.querySelectorAll('[data-qube-src]').forEach((element) => {
          element.setAttribute('src', element.dataset.qubeSrc);
          element.removeAttribute('data-qube-src');
        });

        slide.dataset.loaded = 'true';
        return image;
      }

      queueNextImage() {
        if (!this.autoplay || !this.pageReady || !this.inView || document.hidden || this.userPaused) return;

        this.cancelQueuedImage();

        const nextIndex = (this.index + 1) % this.slides.length;
        if (this.slides[nextIndex]?.dataset.loaded === 'true') return;

        const load = () => {
          this.idleId = null;
          this.idleType = null;

          if (!document.hidden && this.inView && !this.userPaused) {
            this.loadSlide(nextIndex, 'low');
          }
        };

        if ('requestIdleCallback' in window) {
          this.idleType = 'idle';
          this.idleId = window.requestIdleCallback(load, { timeout: 1200 });
        } else {
          this.idleType = 'timeout';
          this.idleId = window.setTimeout(load, 1200);
        }
      }

      cancelQueuedImage() {
        if (this.idleId === null) return;

        if (this.idleType === 'idle') window.cancelIdleCallback?.(this.idleId);
        if (this.idleType === 'timeout') window.clearTimeout(this.idleId);

        this.idleId = null;
        this.idleType = null;
      }

      onWindowLoad() {
        this.pageReady = true;
        this.queueNextImage();
        this.schedule();
      }

      onVisibilityChange() {
        if (document.hidden) {
          this.cancelQueuedImage();
        } else {
          this.queueNextImage();
        }

        this.schedule();
      }

      show(index, source = 'manual') {
        const nextIndex = (index + this.slides.length) % this.slides.length;

        if (nextIndex === this.index) {
          if (source !== 'auto') this.schedule();
          return;
        }

        if (nextIndex === this.pendingIndex) return;

        this.cancelQueuedImage();
        this.pendingIndex = nextIndex;
        const image = this.loadSlide(nextIndex, source === 'auto' ? 'low' : 'high');
        const activate = () => {
          if (!this.isConnected || this.pendingIndex !== nextIndex) return;

          this.pendingIndex = null;
          this.index = nextIndex;
          this.syncSlides();
          this.queueNextImage();
          this.schedule();
        };

        if (!image || image.complete) {
          activate();
          return;
        }

        const reveal = () => {
          if (typeof image.decode !== 'function') {
            activate();
            return;
          }

          image.decode().then(activate, activate);
        };

        image.addEventListener('load', reveal, { once: true });
        image.addEventListener('error', activate, { once: true });
      }

      syncSlides() {
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');

          this.slideControls[index].forEach((control) => {
            if (active) {
              if (control.dataset.qubeManagedTab === 'true') {
                control.removeAttribute('tabindex');
                delete control.dataset.qubeManagedTab;
              }
            } else {
              control.tabIndex = -1;
              control.dataset.qubeManagedTab = 'true';
            }
          });
        });

        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (this.status) this.status.textContent = `Poster ${this.index + 1} of ${this.slides.length}`;
      }

      schedule() {
        window.clearTimeout(this.timer);
        window.cancelAnimationFrame(this.progressFrame);
        this.progressFrame = null;

        const running = this.autoplay
          && this.pageReady
          && !this.userPaused
          && !this.interactionPaused
          && this.inView
          && !document.hidden;

        this.classList.remove('is-running');

        if (!running) return;

        this.progressFrame = window.requestAnimationFrame(() => {
          this.progressFrame = null;
          this.classList.add('is-running');
        });
        this.timer = window.setTimeout(() => this.show(this.index + 1, 'auto'), this.interval);
      }

      setInteractionPaused(paused) {
        this.interactionPaused = paused;
        this.schedule();
      }

      onControlsClick(event) {
        const dot = event.target.closest('[data-qube-hero-dot]');
        const toggle = event.target.closest('[data-qube-hero-toggle]');

        if (dot) {
          this.show(Number(dot.dataset.qubeHeroDot));
          return;
        }

        if (!toggle) return;

        this.userPaused = !this.userPaused;
        this.classList.toggle('is-user-paused', this.userPaused);
        toggle.setAttribute('aria-label', this.userPaused ? 'Resume slideshow' : 'Pause slideshow');
        toggle.setAttribute('title', this.userPaused ? 'Resume slideshow' : 'Pause slideshow');

        if (this.userPaused) {
          this.cancelQueuedImage();
        } else {
          this.queueNextImage();
        }

        this.schedule();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + 1);
        }
      }

      onPointerDown(event) {
        const isPrimaryButton = event.pointerType !== 'mouse' || event.button === 0;

        if (!event.isPrimary || !isPrimaryButton || event.target.closest('a, button')) return;

        this.pointerId = event.pointerId;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.deltaX = 0;
        this.pointerAxis = null;
        this.preparedSwipeIndex = null;
        this.viewport.addEventListener('pointermove', this.handlePointerMove, { passive: false });
      }

      onPointerMove(event) {
        if (event.pointerId !== this.pointerId) return;

        const deltaX = event.clientX - this.startX;
        const deltaY = event.clientY - this.startY;

        if (!this.pointerAxis) {
          if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 8) return;

          this.pointerAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
          if (this.pointerAxis === 'y') {
            this.stopPointerTracking(event);
            return;
          }

          this.viewport.setPointerCapture?.(event.pointerId);
        }

        if (this.pointerAxis !== 'x') return;

        if (event.cancelable) event.preventDefault();
        this.deltaX = deltaX;

        const direction = deltaX < 0 ? 1 : -1;
        const targetIndex = (this.index + direction + this.slides.length) % this.slides.length;
        if (targetIndex !== this.preparedSwipeIndex) {
          this.preparedSwipeIndex = targetIndex;
          this.loadSlide(targetIndex, 'high');
        }
      }

      onPointerEnd(event) {
        if (event.pointerId !== this.pointerId) return;

        const shouldMove = event.type !== 'pointercancel'
          && this.pointerAxis === 'x'
          && Math.abs(this.deltaX) >= 44;
        const direction = this.deltaX < 0 ? 1 : -1;

        this.stopPointerTracking(event);

        if (!shouldMove) return;

        this.suppressClick = true;
        this.show(this.index + direction);
        window.clearTimeout(this.clickResetTimer);
        this.clickResetTimer = window.setTimeout(() => {
          this.suppressClick = false;
        }, 0);
      }

      stopPointerTracking(event) {
        const pointerId = event?.pointerId ?? this.pointerId;
        if (pointerId !== null && this.viewport.hasPointerCapture?.(pointerId)) {
          this.viewport.releasePointerCapture(pointerId);
        }

        this.viewport.removeEventListener('pointermove', this.handlePointerMove);
        this.pointerId = null;
        this.pointerAxis = null;
        this.preparedSwipeIndex = null;
      }

      onClickCapture(event) {
        if (!this.suppressClick) return;

        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }
    }

    customElements.define(elementName, QubePosterHero);
  })();

  } catch(e) { console.error(e); }
})();
})();
